import { Action, ActionReducer, createFeature } from '@ngrx/store';
import {
    AuctionLotsFetchedSuccessfulAction,
    AuctionLotsFetchedSuccessfulActionProps,
    SelectedAuctionLotsServiceActions,
    SelectedAuctionUIActions,
} from './selected-auction.actions';
import { AuctionLotHighlightedListItem } from '@viewbid/ts-angular-client';

export const selectedAuctionFeatureKey: string = 'selectedAuction';

export interface SelectedAuctionState {
    result: AuctionLotHighlightedListItem[] | null | Error;
    isLoading: boolean;
    hasError: boolean;
    count: number;
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
}

export const initialState: SelectedAuctionState = {
    result: null,
    isLoading: false,
    hasError: false,
    count: 0,
    page: 0,
    pageSize: 0,
    totalCount: 0,
    totalPages: 0,
};

export const selectedAuctionStateReducer: ActionReducer<
    SelectedAuctionState,
    Action
> = (
    state: SelectedAuctionState = initialState,
    action: Action,
): SelectedAuctionState => {
    switch (action.type) {
        case SelectedAuctionUIActions.SelectAuctionAction: {
            const newState: SelectedAuctionState = { ...state };
            newState.isLoading = true;
            newState.hasError = false;
            newState.result = null;
            newState.count = 0;
            newState.page = 0;
            newState.pageSize = 0;
            newState.totalCount = 0;
            newState.totalPages = 0;
            return newState;
        }
        case SelectedAuctionLotsServiceActions.AuctionLotsFetchedSuccessfulAction: {
            const AuctionLotsFetchedSuccessfulAction: AuctionLotsFetchedSuccessfulAction =
                action as AuctionLotsFetchedSuccessfulAction;
            const props: AuctionLotsFetchedSuccessfulActionProps =
                AuctionLotsFetchedSuccessfulAction.props;
            const newState: SelectedAuctionState = { ...state };
            newState.isLoading = false;
            newState.hasError = false;
            if (props.result.data) {
                newState.result = props.result.data.map(
                    (res: AuctionLotHighlightedListItem) => res,
                );
                newState.page = props.result.page ?? 0;
                newState.pageSize = props.result.pageSize ?? 0;
                newState.totalCount = props.result.totalCount ?? 0;
                newState.totalPages = props.result.totalPages ?? 0;
            }
            return newState;
        }
        case SelectedAuctionLotsServiceActions.AuctionLotsFetchedFailedAction: {
            const newState: SelectedAuctionState = { ...state };
            newState.isLoading = false;
            newState.result = new Error('unable to load auction');
            newState.hasError = true;
            newState.count = 0;
            newState.page = 0;
            newState.pageSize = 0;
            newState.totalCount = 0;
            newState.totalPages = 0;
            return newState;
        }
        default:
            return state;
    }
};

// eslint-disable-next-line
export const selectedAuctionFeature = createFeature({
    name: selectedAuctionFeatureKey,
    reducer: selectedAuctionStateReducer,
});
